/**
 * Web端菜单ID常量映射
 * 保持向后兼容
 */
const MenuIds = {
  // Web端菜单ID
  ShopManage: 1, // 门店管理
  CoachManage: 2, // 教练管理
  StudentManage: 3, // 学员管理
  FeedbackManage: 4, // 学员反馈
  ActivityManage: 5, // 活动设置
  AccountManage: 6, // 账号管理
  RoleManage: 7, // 角色管理
  CourseManage: 8, // 课程管理
  SaleManage: 9, // 销售管理
  StatisticPanel: 10, // 统计面板
  ProductManage: 11, // 产品管理
  CourseScheduleManage: 12, // 课程表管理
  ContractManage: 13, // 合同管理
  TerminalManage: 14, // 终端管理
  DiscountManage: 15, // 折扣管理
  CommunityManage: 16, // 社群管理
  TagManage: 17, // 标签管理
  TicketManage: 10007, // 票务管理
  InsuranceManage: 18, // 保险管理

  // Web端子菜单ID
  StudentManageSkill: 31, // 技能评级
  StudentManageExport: 32, // 导出
  StudentManageAchievement: 33, // 点亮成就
  StudentManageFeedback: 34, // 课程反馈
  StudentManageAddRemark: 35, // 学员备注
  StudentManageOrder: 36, // 购买记录
  StudentManageAssignSalesman: 37, // 设置销售员
  StudentManageCourseRecord: 38, // 课程记录
  OrderAudit: 91, // 销售审核
  SalesmanManage: 92, // 销售员管理
  ProductManageGoods: 111, // 总仓产品
  ProductManageShopGoods: 112, // 门店产品管理
  ProductManageGoodsReturn: 1121, // 批量退货
  ProductManageGoodsApply: 113, // 门店产品申请
  ProductManageGoodsCatalog: 114, // 产品自定义目录
  ProductManageGoodsCheck: 115, // 盘点审核
};

/**
 * Web端权限检查函数
 * @param {number} menuId - 菜单ID
 * @returns {boolean} 是否有权限
 */
function authorized(menuId) {
  // 从localStorage获取用户已授权的菜单
  let authorizedMenus = null;
  try {
    const storedMenus = localStorage.getItem("authorizedMenus");
    if (storedMenus) {
      authorizedMenus = JSON.parse(storedMenus);
    }
  } catch (error) {
    console.warn("Failed to parse authorizedMenus from localStorage:", error);
    return false;
  }

  if (!authorizedMenus || !Array.isArray(authorizedMenus)) {
    return false;
  }

  // 查找菜单是否在授权列表中
  const menu = authorizedMenus.find((item) => item.id === menuId);
  return menu != null;
}

export { MenuIds, authorized };
